import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const MEMBER_TIERS = new Set(["beta", "paid", "lifetime"]);

const ITEMS = [
  { to: "/member/model-picks", label: "Model Picks" },
  { to: "/member/today-strongest", label: "Today's Strongest" },
  { to: "/member/form-graphs", label: "Form Graphs", badge: "NEW" },
  { to: "/member/ask", label: "Ask the Notebook", featured: true, badge: "NEW" },
  { to: "/member/tissue", label: "Tissue" },
  { to: "/member/going-bias", label: "Going Bias" },
  { to: "/member/backtests", label: "Backtests" },
  { to: "/member/breeding", label: "Breeding Stats" },
  { to: "/member/trainer-stats", label: "Trainer Stats" },
  { to: "/member/help", label: "Help" },
];

export default function MembersBar() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user || !MEMBER_TIERS.has(user.subscription_tier)) return null;

  return (
    <div className="members-bar">
      <Link to="/member/tissue" className="members-bar-logo">
        Mispriced
        <span>Members</span>
      </Link>
      <ul className="members-bar-nav">
        {ITEMS.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              className={({ isActive }) =>
                [item.featured ? "is-featured" : "", isActive ? "active" : ""]
                  .filter(Boolean).join(" ") || undefined
              }
            >
              {item.label}
              {item.badge && (
                <span className="members-bar-pill">{item.badge}</span>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
}
